import React, { useState, useCallback } from 'react';
import SuggestionsTable from './SuggestionTable';
import InactiveProvidersList from './InactiveProviders.jsx';
import UserManagement from './UserManagement';
import PostsManagement from './PostsManagement';
import CategoryManagement from './CategoryManagement';
import LocationManagement from './LocationManagement';
import NotificationSender from './NotificationSender';
import FilesManagement from './FilesManagement';
import EmailSender from './EmailSender';
import MigrationPanel from './MigrationPanel';
import ApiTester from './ApiTester';
import PartnershipManagement from './PartnershipManagement';
import AdminLayout from './AdminLayout/AdminLayout';
import AdminHome from './AdminHome/AdminHome';
import Estadisticas from './Estadisticas/Estadisticas';
import { isValidSection } from './AdminLayout/adminNavConfig';
import { useTheme } from '../../utils/ThemeContext';
import './adminTheme.css';
import './ControlPanel.css';

const ControlPanel = () => {
    const { theme, toggleTheme } = useTheme();
    const [selectedSection, setSelectedSection] = useState('inicio');
    const [pendingSuggestions, setPendingSuggestions] = useState(0);

    const handleSelectSection = useCallback((key) => {
        if (!isValidSection(key)) return;
        setSelectedSection(key);
    }, []);

    const handleCountsChanged = useCallback((counts) => {
        const unseen = counts?.suggestions?.unseen ?? 0;
        setPendingSuggestions(unseen);
    }, []);

    const renderSection = () => {
        switch (selectedSection) {
            case 'estadisticas':
                return <Estadisticas />;
            case 'proveedores':
                return <InactiveProvidersList />;
            case 'sugerencias':
                return <SuggestionsTable />;
            case 'usuarios':
                return <UserManagement />;
            case 'posts':
                return <PostsManagement />;
            case 'categorias':
                return <CategoryManagement />;
            case 'partnerships':
                return <PartnershipManagement />;
            case 'locations':
                return <LocationManagement />;
            case 'notificaciones':
                return <NotificationSender />;
            case 'emails':
                return <EmailSender />;
            case 'files':
                return <FilesManagement />;
            case 'migration':
                return <MigrationPanel />;
            case 'api-tester':
                return <ApiTester />;
            case 'inicio':
            default:
                return (
                    <AdminHome
                        onNavigate={handleSelectSection}
                        onCountsChanged={handleCountsChanged}
                    />
                );
        }
    };

    return (
        <AdminLayout
            selectedSection={selectedSection}
            onSelectSection={handleSelectSection}
            theme={theme}
            onToggleTheme={toggleTheme}
            pendingSuggestions={pendingSuggestions}
            onOpenSuggestions={() => handleSelectSection('sugerencias')}
        >
            {renderSection()}
        </AdminLayout>
    );
};

export default ControlPanel;
